
export type UploadStatus = {
    inProgress: boolean,
    statusText: string,
}

export const NewUploadStatus: UploadStatus = {
    inProgress: false,
    statusText: "New"
}